import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { StorefrontIcon } from '@linetweet/linetweet-ui';

import styles from './index.module.scss';
import MenuItem from './components/MenuItem';
import { bottomItems, topItems } from './constants';
import { ISettingsSetup } from '../../store/store/slice';
import { Authorized, Roles } from '../Auth';


type IProps = {
  show: boolean;
  storeData: any;
  storeSettingsSetup: ISettingsSetup | null;
  onOpenLanguagesDialog: () => void;
  onSignOut: () => void;
};

const NavigationMenu = (props: IProps) => {
  const intl = useIntl();
  const { show, storeData, storeSettingsSetup, onOpenLanguagesDialog, onSignOut } = props;
  const { pathname } = useLocation();

  const topBlockItems = useMemo(() => topItems.map(item => {
      if (storeSettingsSetup?.settingsPagesToShow?.indexOf(item.link.replace('/', '')) !== -1) {
        return (
          <MenuItem
            key={item.text}
            text={intl.formatMessage({ id: item.text })}
            active={pathname === item.link}
            Icon={item.icon}
            link={item.link}
          />
        );
      } else {
        return <></>
      }
    }),
    [pathname, intl, storeSettingsSetup]);

  const bottomBlockItems = useMemo(() => bottomItems.map(item => {
        let onClick;

        if (!onClick && item.type) {
          item.type === 'language'
            ? onClick = onOpenLanguagesDialog
            : onClick = onSignOut;
        }

        return (
          <MenuItem
            key={item.text}
            Icon={item.icon}
            text={intl.formatMessage({ id: item.text })}
            onClick={onClick}
            link={item.link}
          />
        );
      },
    ),
    [onOpenLanguagesDialog, onSignOut, intl]);

  return (
    <Box className={clsx(styles.navigationMenu, { [styles.hidden]: !show })}>
      <Box className={styles.title}>{intl.formatMessage({ id: 'common.storeSettings' })}</Box>
      <Authorized roles={[Roles.MANAGER]}>
        <Box className={styles.storeName}>
          <StorefrontIcon />
          {storeData?.name}
        </Box>
      </Authorized>
      <hr className={styles.line} />
      <Box className={styles.mainBlock}>
        <Box className='d-flex flex-column'>
          <Authorized roles={[Roles.MANAGER]}>
            {topBlockItems}
          </Authorized>
        </Box>
        <Box>
          <Box className='d-flex flex-column'>{bottomBlockItems}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NavigationMenu;
